/**
 * Retrieves string data from sessionStorage by key.
 *
 * @param {string} key - The key to retrieve the data from sessionStorage.
 * @param {string | null} [defaultValue=null] - The default value to return if sessionStorage is not available or the data is not found.
 * @returns {string | null} The retrieved data as a string or the default value if sessionStorage is not available or the data is not found.
 */
export function getSessionData(key: string, defaultValue: string | null = null): string | null {
	let sessionData: string | null;

	if (typeof sessionStorage !== 'undefined') {
		// sessionStorage is available
		sessionData = sessionStorage.getItem(key);
	} else {
		// sessionStorage is not available
		console.error('Session storage is not available.');
		sessionData = null;
	}

	return sessionData !== null ? sessionData : defaultValue;
}

/**
 * Sets data in sessionStorage.
 *
 * @template T - The type of data to store.
 * @param {string} key - The key under which to store the data in sessionStorage.
 * @param {T} value - The data to store in sessionStorage.
 */
export function setSessionData<T>(key: string, value: T): void {
	if (typeof sessionStorage !== 'undefined') {
		try {
			sessionStorage.setItem(key, JSON.stringify(value));
		} catch (error) {
			console.error('Error setting session data:', error);
		}
	} else {
		console.error('Session storage is not available.');
	}
}
